<template>
  <div class="bold-box">
    <slot/>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import '~style/variables';

.bold-box {
  background: $c-info-light;
  padding: 0.5rem;
  border-radius: $r;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/BoldBox.vue